import Api from '@teko/api';
import { accessTokenInterceptor } from '@teko/auth';
import { getError } from './error.es.js';

class TerraService {
    constructor(apiUrl) {
        this.terraApi = new Api(apiUrl, getError);
        this.terraApi.addInterceptor(accessTokenInterceptor);
    }
    async linkTakaMembership(body, loyaltyClientId) {
        const url = '/api/v1/linkTakaMembership';
        const { data } = await this.terraApi.post(url, body, {
            headers: { 'X-Loyalty-Id': loyaltyClientId },
        });
        return data;
    }
    async getInstallmentTerms(merchantMethodCode, amount) {
        const { data } = await this.terraApi.get('/api/v1/payment/terms', {
            params: {
                merchantMethodCode,
                amount,
            },
        });
        return data;
    }
    async registerMembership(request, loyaltyClientId) {
        const url = '/api/v1/registerMember';
        const { data } = await this.terraApi.post(url, request, {
            headers: {
                'X-Loyalty-Id': loyaltyClientId,
            },
        });
        return data;
    }
    async getLoyaltyMemberInfo(loyaltyClientId, phone, memberQrCode) {
        let url = '/api/v1/loyalty/member';
        if (phone) {
            url = url + `?phone=${phone}`;
        }
        else if (memberQrCode) {
            url = url + `?memberQrCode=${memberQrCode}`;
        }
        const { data } = await this.terraApi.get(url, {
            headers: { 'x-loyalty-id': loyaltyClientId },
        });
        return data;
    }
}

export { TerraService };
